/** Removes duplicate values from the array. No guarantee about order of the array. */
export function dedupe<T>(array: Array<T>) {
  return Array.from(new Set(array))
}

export function median(arrar: Array<any>) {
  const mid = Math.floor(arrar.length / 2)
  const nums = [...arrar].sort((a, b) => a - b)
  return arrar.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2
}

export function commaSeparatedStringToArray(value: string): string[] {
  const cleaned = value.replace(/\r?\n|\r/g, ',')
  return cleaned
    .split(',')
    .filter((item) => item.length > 0)
    .map((item) => item.replace(/^[ ]+|[ ]+$/g, ''))
}

export function sum(arr: number[]) {
  return arr.reduce((partialSum, a) => partialSum + a, 0)
}
